import { moment } from "shared/cubiq-model-multi-asset";

export const load_tzdb = async function load_tzdb() {
  try {
    let response = await fetch("/assets/tz/latest.json");
    let tzDB = null;
    if (response.status === 200) {
      let data = await response.text();
      tzDB = JSON.parse(data);
    }
    moment.tz.load(tzDB);
  } catch (e) {
    console.log(e);
  }
};
